import type { IUserLoginResponse } from "../types/auth";

export function parseStoredLogin(raw: string): IUserLoginResponse | null {
  if (!raw) return null;

  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return null;
  }

  if (
    typeof parsed !== "object" ||
    parsed === null ||
    typeof (parsed as { token?: unknown }).token !== "string"
  ) {
    return null;
  }

  return parsed as IUserLoginResponse;
}
